import React from 'react';

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * Oblique Design System — Card
 * ═══════════════════════════════════════════════════════════════════════════
 */

export function Card({
    children,
    variant = 'surface', // 'surface', 'subtle', 'glass', 'outline'
    padding = 'md', // 'none', 'sm', 'md', 'lg'
    className = '',
    onClick,
    hoverable = false,
    ...props
}) {
    const variants = {
        surface: 'bg-[var(--bg-surface)] text-[var(--text-primary)] shadow-[0_2px_12px_rgba(0,0,0,0.04)] border border-[var(--border)]',
        subtle: 'bg-[var(--bg-muted)] border border-transparent text-[var(--text-primary)]',
        glass: 'bg-[var(--bg-surface)]/80 backdrop-blur-md border border-[var(--border)] shadow-[0_4px_24px_rgba(0,0,0,0.06)]',
        outline: 'bg-transparent border border-[var(--border-strong)] text-[var(--text-primary)]',
    };

    const paddings = {
        none: 'p-0',
        sm: 'p-4',
        md: 'p-6',
        lg: 'p-8',
    };

    const baseStyles = 'rounded-[12px] transition-all duration-200 overflow-hidden flex flex-col';
    const hoverStyles = hoverable ? 'hover:shadow-[0_8px_24px_rgba(0,0,0,0.08)] hover:border-[var(--border-strong)] cursor-pointer hover:-translate-y-0.5' : '';

    return (
        <div
            onClick={onClick}
            className={`${baseStyles} ${variants[variant]} ${paddings[padding]} ${hoverStyles} ${className}`}
            {...props}
        >
            {children}
        </div>
    );
}

export function CardHeader({ className = '', children, ...props }) {
    return (
        <div className={`flex flex-col gap-1.5 pb-4 ${className}`} {...props}>
            {children}
        </div>
    );
}

export function CardTitle({ className = '', children, ...props }) {
    return (
        <h3 className={`text-[16px] font-semibold tracking-tight text-[var(--text-primary)] leading-none ${className}`} {...props}>
            {children}
        </h3>
    );
}

export function CardDescription({ className = '', children, ...props }) {
    return (
        <p className={`text-[13px] text-[var(--text-secondary)] leading-relaxed ${className}`} {...props}>
            {children}
        </p>
    );
}
